export default __webpack_public_path__ + "assets/models/c29a52046ea2ce293ecc5ecbab6874f7.glb";